import React from "react";

import { Dropdown, Icon } from "@culturehq/components";
import { Trans } from "app/utils";

interface TranslationOptionProps {
  onSelectTranslation: (value: boolean) => void;
}

const TranslationOption: React.FC<TranslationOptionProps> = ({ onSelectTranslation }) => (
  <Dropdown.Option
    className="DownloadDp-Option"
    value="add_translation"
  >
    <Icon icon="translate" />
    <Trans>Add Translation</Trans>
  </Dropdown.Option>
);

export default TranslationOption;
